import { useEffect } from "react";
import { WarehouseDetailsViewModel } from "../../../viewmodels/setup/warehouses/WarehouseDetailsViewModel";

import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";

import { withRouter } from "../../../shared/utility";

import SlideOver from "../../../components/slideOver/SlideOver";
import EmptyModal from "../../../components/modals/EmptyModal";
import TableLoadingSkeleton from "../../../components/shared/TableLoadingSkeleton";

import AuditActionLink from "../../../components/audit/AuditActionLink";
import { useParams } from "react-router-dom";

import Button from "../../../components/controls/Button";

function WarehouseDetails(props) {
  const { addSnackbar, logout } = props;

  const { warehouseId } = useParams();

  const {
    getWarehouseDetails,
    loading,
    warehouse,
    setSlideOver,
    slideOver,
    locations,
    setEmptyModelOpen,
    emptyModal,
    openAddLocationSlideOver,
    getWarehouseLocations,
    askDeleteLocation,
  } = WarehouseDetailsViewModel(logout, warehouseId, addSnackbar);

  useEffect(() => {
    getWarehouseDetails();
    getWarehouseLocations();
  }, []);

  return (
    <div>
      <div className="mt-2 px-4 sm:px-8">
        <div className="sm:items-center">
          <div className="sm:flex sm:items-center sm:justify-between sm:flex-auto">
            <h1 className="text-2xl font-semibold leading-6 text-gray-900">
              {warehouse.name}
            </h1>
            {warehouse.id != null && (
              <AuditActionLink
                slug="warehouse"
                id={warehouse.id}
                name={warehouse.name}
              />
            )}
          </div>
          {/* <div className="mt-5">
            <WarehouseDetailsForm warehouse={warehouse} />
          </div> */}
          <div className="px-4 py-5 sm:px-4 card-custom mt-5">
            <div className="sm:flex sm:items-center">
              <div className="flex flex-grow">
                <h1 className="text-base font-semibold leading-6 text-gray-900 flex-grow">
                  Locations
                </h1>
                <Button className="ml-5" onClick={() => openAddLocationSlideOver(false, null, null)}>Add location</Button>
              </div>
            </div>
            <div className="inline-block min-w-full py-2 align-middle">
              {loading ? (
                <TableLoadingSkeleton rows={5} columns={4} />
              ) : (
                <div className="overflow-hidden">
                  <table className="min-w-full divide-y divide-gray-300">
                    <thead className="bg-white">
                      <tr>
                        <th
                          scope="col"
                          className="py-3 pr-3 text-left text-sm font-semibold text-gray-900"
                        >
                          Name
                        </th>
                        <th
                          scope="col"
                          className="relative py-3.5 pl-3 pr-4 sm:pr-6"
                        ></th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {locations.data.length === 0 ? (
                        <tr>
                          <td className="whitespace-nowrap py-1.5 pr-3 text-sm font-medium text-gray-500">
                            No locations, please add one
                          </td>
                        </tr>
                      ) : (
                        locations.data.map((location, index) => (
                          <tr key={location.id}>
                            <td className="whitespace-nowrap py-1.5 pr-3 text-sm font-medium text-gray-500">
                              {location.name}
                            </td>
                            <td className="relative whitespace-nowrap py-1.5 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                              <Button
                                className="ml-2"
                                onClick={() =>
                                  openAddLocationSlideOver(
                                    true,
                                    location,
                                    index
                                  )
                                }
                              >
                                Edit
                              </Button>
                              <Button
                                className="ml-2"
                                variant="danger"
                                onClick={() => {
                                  askDeleteLocation(warehouse, index);
                                }}
                              >
                                Delete
                              </Button>
                              <AuditActionLink
                                slug="warehouse-location"
                                id={location.id}
                                name={location.name}
                              />
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WarehouseDetails)
);
